import _ from 'lodash';
import { createModel } from '@rematch/core';

import { RootModel } from '../';
import { get, post } from '../../api/api';
import { apiUrls, replaceUrls } from '../../api/apiUrls';
import ContentState from '../../interfaces/ContentState';

export default createModel<RootModel>()({
  state: {
    loading: false,
    configs: {
      facebook: '',
      twitter: '',
      lotto: {
        title: '',
        description: '',
        keywords: ''
      },
      sports: {
        title: '',
        description: '',
        keywords: ''
      },
      racing: {
        title: '',
        description: '',
        keywords: ''
      }
    },
    passwordStrength: { minLength: 8, maxLength: 20, minStrength: 1 },
    passwordValidation: { tips: [], strength: 1 },
    pageSelected: {},
    countryByIP: '',
    contentLobbies: [],
    retailHome:[
      { title: 'cancelTicket', position:1, shortcut: { name: 'F8', code: 119 }, link: '/cancel-ticket', show: true },
      { title: 'payoutTicket', position: 2, shortcut: { name: 'F9', code: 120 }, link: '/payout-ticket', show: true },
      { title: 'reprintLastTicket', position: 3, link: '/reprint', show: true },
      { title: 'customerLogin', position: 4, link:'#customer-login', show: true },
      { title: 'transactions', position: 5, shortcut: { name: 'F1', code:112 }, link: '/transactions', show: true },
      { title: 'endShift', position: 6, shortcut: { name: 'F10', code: 121 }, link: '/end-of-shift', show: true },
      { title: 'ficaForm', position:7, link: '#fica-form', show: true },
      { title: 'cards', position: 8, link: '/cards', show: true },
      { title: 'getTicket', position: 9, link: 'get-ticket', show: true },
      { title: 'register', position: 10, link: '#register-retail', show: true },
      { title: 'registerRewards', position: 11, link: '#register-rewards', show: true },
      { title: 'tests', position: 12, link: '/tests', show: true },
      { title: 'pause', position: 13, shortcut: { name: 'F11', code: 122 }, link: '#', show: true },
      { title: 'sessionAdmin', position: 14, link: '/session-admin', show: true },
      { title: 'secondScreen', position: 16, link: '/second-screen-menu', show: true },
      { title: 'cancelTicketRequest', position: 17, link: '/cancel-ticket-request', show: true },
      { title: 'autoTransactions', position: 18, link: '/auto-transactions', show: true }
    ],
    autoTransactions:[
      { name: 'transferFloatIn', function: 'FLOAT_IN', disabled: false, id: 9, subtitle:'tillToAdminTill' },
      { name: 'transferFloatOut', function: 'FLOAT_OUT', disabled: false, id: 8, subtitle:'adminTillToTill' },
      { name: 'transferSafeOut', function: 'SAFE_OUT', subtitle: 'admintTillToSafe', id: 6 },
      { name: 'transferSafeIn', function: 'SAFE_IN', subtitle: 'safeToAdminTill', id: 7 },
      { name: 'transferG4sOut', function: 'G4S_OUT', id: 10, subtitle:'adminTillToG4s' }

    ],
    secondScreen:[
      { title: 'betslip', position:1, link: '/cancel-ticket', show: true },
      { title: 'customerLogin', position: 2, link: '/payout-ticket', show: true },
      { title: 'showTicket', position: 2, link: '/payout-ticket', show: true }
    ],
    functionality: [
      { name: 'calculator', key: ']' },
      { name: 'cashLog', key: '#' }
    ],
    modals: [{
      id: null,
      trigger: null,
      delayToShow: null,
      showNrTime: null,
      configuration: null,
      banner: {
        id: null,
        body: null
      }
    }],
    template: {
      header: {
        show: true,
        components: []
      },
      leftSideBar: {
        show: true,
        components: [{ type: 'Filter' }],
        collapse: true,
        collapsed: false
      },
      rightSideBar: {
        show: true,
        components: [{ type: 'Betslip' }],
        collapse: true,
        collapsed: false
      },
      main: {
        show: true,
        components: []
      },
      footer: {
        show: true,
        components: [],
        columns: []
      }
    },
    menu: [
      {
        title: 'home',
        link: '/',
        showInRetail: true,
        shortcut: {
          code: 123,
          name: 'F12'
        }
      },
      {
        title: 'racing',
        link: '/racing/today',
        showSubMenuMobile: false,
        shortcut: {
          code: 115,
          name: 'F5'
        },
        subMenu: [
          { title: 'yesterday', link: '/racing/yesterday' },
          { title: 'today', link: '/racing/today' },
          { title: 'tomorrow', link: '/racing/tomorrow' }
        ],
        showInRetail: true,
        showTrading: true
      },
      {
        title: 'prematch',
        link: '/sports-betting/prematch',
        shortcut: {
          code: 117,
          name: 'F6'
        },
        showInRetail: true
      },
      {
        title: 'live',
        link: '/sports-betting/live',
        showInRetail: true
      },
      {
        title: 'lotto',
        link: '/lotto',
        shortcut: {
          code: 118,
          name: 'F7'
        },
        showInRetail: true
      },
      {
        title: 'betOnGames',
        link: '/bet-on-games',
        showInRetail: false
      },
      {
        title: 'liveScore',
        link: 'https://ls.sir.sportradar.com/keithhobexchange/en'
      },
      {
        title: 'statistics',
        link: 'https://s5.sir.sportradar.com/keithhobexchange'
      },
      {
        title: 'sportal',
        link: 'http://sportal.betxchange.com/'
      },
      {
        title: 'deposit',
        link: '/account/deposit?page=depositFunds',
        private: true
      },
      {
        title: 'cards',
        link: null,
        showSubMenuMobile: false,
        subMenu: [
          { id: 1, title: 'card1', link: '/racing/today?calendar=&type=horses&card=1' },
          { id: 2, title: 'card2', link: '/lotto?card=2' },
          { id: 3, title: 'card3', link: '/sports-betting/prematch?card=3' },
          { id: 4, title: 'card4', link: '/racing/today?calendar=&type=dogs&card=4' },
          { id: 5, title: 'card5', link: '/racing/today?calendar=&type=dogs&card=5' },
          { id: 6, title: 'card6', link: '/sports-betting/prematch?card=6' },
          { id: 7, title: 'card7', link: '/racing/today?calendar=&type=horses&card=7' },
          { id: 8, title: 'card8', link: '/racing/today?calendar=&type=horses,dogs&card=8' },
          { id: 9, title: 'card9', link: '/lotto?card=9' }
        ],
        useActiveClass: false,
        showInRetail: true,
        showInBetSite: false
      },
      {
        title: 'registerBet',
        link:'/register-bet',
        useActiveClass: true,
        showInRetail: true,
        showInBetSite: false
      }
    ],
    settings: {
      showBalance: localStorage.getItem('showBalance') === 'false' ? false : true,
      loginTimeout: 300000
    },
    stakingRules: {
      sports: {
        inPlay: {
          default: 2,
          minimum: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        single: {
          default: 2,
          minimum: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        acca: {
          default: 2,
          minimum: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        system: {
          default: 2,
          minimum: 0,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        }
      },
      racing: {
        tote: {
          default: 2,
          minimum: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        fixedOdds: {
          default: 5,
          minimum: 1,
          maximum: 10,
          minBetslip: 1,
          maxBetslip: 100
        },
        acca: {
          default: 2,
          minimum: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        system: {
          default: 2,
          minimum: 0,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        }
      },
      lotto: {
        single: {
          default: 2,
          minimum: 2,
          fastModeDefault: 2,
          maximum: 10,
          minBetslip: 2,
          maxBetslip: 100
        },
        acca: {
          default: 2,
          minimum: 2,
          maximum: 10,
          fastModeDefault: 2,
          minBetslip: 2,
          maxBetslip: 100
        },
        system: {
          default: 2,
          minimum: 0,
          maximum: 10,
          fastModeDefault: 2,
          minBetslip:2,
          maxBetslip: 100
        }
      }
    },
    rangeFilterButtons: [
      { value: 24, label: '24 hours' },
      { value: 48, label: '48 hours' },
      { value: 168, label: '7 days' },
      { value: 0, label: 'Date' }
    ],
    rangeFilterDropdown: [
      { value: 'all', label: 'all' },
      { value: 'sport', label: 'sport' },
      { value: 'horses', label: 'horses' },
      { value: 'numbers', label: 'numbers' }
    ],
    betType: [
      { value: 'allTypes', label: 'allTypes' },
      { value: 'single', label: 'single' },
      { value: 'acca', label: 'acca' },
      { value: 'system', label: 'system' }
    ],
    modal: '',
    openMenu: '',
    drawer: '',
    keys: {
      changeInput: 9,
      revert: 16,
      information: 73,
      submit:13
    },
    hasCountDown: true,
    showSecondScreen: ''
  } as ContentState,

  reducers: {
    setLoading(state: ContentState, payload: boolean) {
      return { ...state, loading: payload };
    },

    setConfig(state: ContentState, payload: ContentState['configs']) {
      return { ...state, configs: payload };
    },

    setShowSecondScreen(state: ContentState, payload: string){
      return { ...state, showSecondScreen: payload };
    },

    setPasswordStrength(state: ContentState, payload: ContentState['passwordStrength']) {
      if (payload) {
        return { ...state, passwordStrength: payload };
      } else {
        return { ...state };
      }
    },

    setTemplates(state: ContentState, payload: ContentState['template']) {
      return { ...state, template: payload };
    },

    setContentLobbies(state: ContentState, payload: ContentState['contentLobbies']) {
      return { ...state, contentLobbies: payload };
    },

    setMenu(state: ContentState, payload: ContentState['contentLobbies']) {
      const menu: ContentState['menu'] = [...state.menu ];

      _.map(payload, lobby => {
        menu.push({
          label: lobby.title,
          link: `/lobby/${ lobby.slug }`,
          subMenu: _.map(lobby.tabs, tab => ({ label: tab.title, link: `/lobby/${ lobby.slug }` })),
          useActiveClass: false,
          showSubMenuMobile: false
        });
      });

      return { ...state, menu: [ ...menu ] };
    },

    setContentModals(state: ContentState, payload: ContentState['modals']) {
      return { ...state, modals: payload };
    },

    setPageSelected(state: ContentState, payload: ContentState['pageSelected']) {
      return { ...state,
        pageSelected: {
          ...payload
        }
      };
    },

    setSettings(state: ContentState, payload: ContentState['settings']) {
      return { ...state, settings: { ...state.settings, ...payload } };
    },

    setPasswordValidation(state: ContentState, payload: ContentState['passwordValidation']) {
      if (payload) {
        return { ...state, passwordValidation: payload };
      } else {
        return { ...state };
      }
    },

    setCountryByIP(state: ContentState, payload: ContentState['countryByIP']) {
      return { ...state, countryByIP: payload };
    },

    setStakingRules(state: ContentState, payload: ContentState['stakingRules']) {
      return { ...state, stakingRules: { ...state.stakingRules, ...payload } };
    },

    setModal(state: ContentState, payload: ContentState['modal']){
      return { ...state, modal: payload };
    },

    setOpenMenu(state: ContentState, payload: ContentState['openMenu']){
      return { ...state, openMenu: payload };
    },

    setDrawer(state: ContentState, payload: ContentState['drawer']) {
      return { ...state, drawer: payload };
    },

    changeSidebar(state: any, payload: { type: string, collapsed: boolean }) {
      return {
        ...state,
        template: {
          ...state.template,
          [payload.type]: {
            ...state.template[payload.type],
            collapsed: payload.collapsed
          }
        }
      };
    },

    collapseSidebar(state: ContentState, payload:string){
      const collapsed = state.template[payload].collapsed;
      const template = state.template[payload];
      return { ...state,  template: { ...state.template, [payload]:{ ...template, collapsed: !collapsed } } };
    },

    setDefaultStake(state:ContentState, payload:number){
      return {
        ...state,
        stakingRules:{
          ...state.stakingRules,
          lotto: {
            ...state.stakingRules.lotto,
            single:{
              ...state.stakingRules.lotto.single,
              fastModeDefault: +payload
            },
            acca:{
              ...state.stakingRules.lotto.acca,
              fastModeDefault: +payload
            },
            system: {
              ...state.stakingRules.lotto.system,
              fastModeDefault: +payload
            }
          }
        }
      };
    }
  },

  effects: (dispatch) => ({
    enableLoading(): void {
      dispatch.content.setLoading(true);
    },

    disableLoading(): void {
      dispatch.content.setLoading(false);
    },

    async getSettings(payload: { companyId: string, shopId: string }): Promise<void> {
      try {
        const response = await get(replaceUrls(apiUrls.settings, { companyId: payload.companyId, shopId: payload.shopId }));
        const { configs, template, passwordStrength, settings, country, contentLobbies, modals } = response.data.results;

        if (response && response.status === 200) {
          dispatch.content.setConfig(configs);
          dispatch.content.setPasswordStrength(passwordStrength);
          if (!_.isEmpty(template)) {
            dispatch.content.setTemplates(template);
          }
          dispatch.content.setContentLobbies(contentLobbies);
          dispatch.content.setMenu(contentLobbies);
          dispatch.content.setContentModals(modals);
          dispatch.content.setCountryByIP(country);

          dispatch.content.setStakingRules(settings.stakingRules);
          const languages = _.map(settings.locales, locale => Object.assign({}, { value: locale.code, label: locale.name }));
          const countries = _.map(Object.keys(settings.countries), countryCode =>
            Object.assign({}, { value: countryCode, text: settings.countries[countryCode] })
          );

          dispatch.odds.setLanguages(languages);
          dispatch.odds.setCountries(countries);
        }

      } catch (error) {
        // TODO: Handle error
      }
    },

    async getStaticPage(payload: string): Promise<void> {
      try {
        const response = await get(`${ apiUrls.content }/page/${ payload }`);

        dispatch.content.setPageSelected(response.data.results);

      } catch (error) {
        // TODO: Handle error
      }
    },

    updateSettings(payload: ContentState['settings']): void {
      const itemName = Object.keys(payload)[0];
      localStorage.setItem(itemName, payload[itemName].toString());

      dispatch.content.setSettings(payload);
    },

    async validatePassword(payload: string): Promise<void> {
      if (payload) {
        try {
          const response = await post(apiUrls.validatePassword, { password: payload });

          response && response.data && dispatch.content.setPasswordValidation(response.data.results);
        } catch (error) {
          // TODO: Handle error
        }
      }
    },

    async getProvinces(payload: string): Promise<void> {
      try {
        const response = await get(replaceUrls(apiUrls.provinces, { country: payload }));

        if (response && response.status === 200) {
          const provinces = _.map(response.data.results, province => Object.assign({}, { value: province.name, text: province.name }));

          dispatch.odds.setProvinces(provinces);
        } else {
          dispatch.toast.showToast({ type: 'error', message: (response && response.data.message) || 'Oops! Something went wrong.' });
        }
      } catch (error) {
        // TODO: Handle error
      }
    },

    modalType(payload: string): void {
      dispatch.content.setModal(payload);
    },

    openMenu(payload:string): void {
      dispatch.content.setOpenMenu(payload);
    },

    openDrawer(drawer: string): void {
      dispatch.content.setDrawer(drawer || '');
    },

    changeSidebarCollapsed(payload: { sidebar: string, isRetail: boolean, width: number }):void {
      if (payload.isRetail && (payload.width >= 1280 && payload.width < 1366)) {
        dispatch.content.changeSidebar({ type: 'leftSideBar', collapsed: true });
        dispatch.content.changeSidebar({ type: 'rightSideBar', collapsed: true });
        dispatch.content.collapseSidebar(payload.sidebar);
      } else {
        dispatch.content.collapseSidebar(payload.sidebar);
      }
    },

    changeFastModeDefaultStake(payload: number){
      dispatch.content.setDefaultStake(payload);
    },

    changeShowSecondScreen(payload: string){
      dispatch.content.setShowSecondScreen(payload);
    }
  })
});
